import { Carousel, type CarouselAutoplayProps, CarouselSlide } from '@ori/presentation-components';
import useTestId from '@ori/testid-generator';
import { useCallback, useMemo, type FC } from 'react';

import { goToPage } from '../../../../utils';
import { Banner } from './components/Banner';
import { BANNERS_CAROUSEL, navigation, pagination, slider } from './constants';
import { Root } from './styles';
import type { BannersCarouselProps } from './types';

export const BannersCarousel: FC<BannersCarouselProps> = ({ items, onOpen }) => {
  const { getTestId } = useTestId();
  const autoplay: CarouselAutoplayProps = useMemo(
    () => ({ enabled: items.length > 1, interval: 5000 }),
    [items.length],
  );

  const onBannerClick = useCallback(
    (url?: string, shouldOpenInvitationOffer?: boolean) => () => {
      if (shouldOpenInvitationOffer) {
        onOpen();
      } else if (url) {
        goToPage(url);
      }
    },
    [onOpen],
  );

  return (
    <Root data-testid={getTestId(BANNERS_CAROUSEL)}>
      <Carousel
        autoplay={autoplay}
        navigation={navigation}
        pagination={pagination}
        slider={slider}
        propagateDragEvent={false}
        id="top-area-banner-carousel"
      >
        {items.map(({ title, url, shouldOpenInvitationOffer }) => (
          <CarouselSlide
            key={url}
            minWidth="100%"
          >
            <Banner
              title={title}
              onClick={onBannerClick(url, shouldOpenInvitationOffer)}
            />
          </CarouselSlide>
        ))}
      </Carousel>
    </Root>
  );
};
